<template>
    <div class="Final Requisition">
      <Loader :active="isLoading" message="রিফিল হচ্ছে..." />
  
      <b-modal 
        v-model="showModal" 
        :title="modalTitle"
        :header-bg-variant="modalVariant"
        header-text-variant="light"
        centered
        no-close-on-backdrop
        hide-header-close
        @hidden="handleModalClose"
      >
        <p class="my-2 text-center" style="font-size: 1.1rem;">{{ modalMessage }}</p>
        
        <div v-if="showClipboard" class="mt-4">
          <div class="bg-light p-3 rounded border position-relative">
              <pre class="mb-0" style="font-size: 0.9rem; font-family: monospace; white-space: pre-wrap; color: #333;">{{ clipboardText }}</pre>
          </div>
        </div>

        <template #modal-footer>
            <div class="w-100 text-center">
                <button v-if="showClipboard" @click="copyToClipboard" class="btn btn-primary font-weight-bold shadow-sm px-4">
                    <i class="fas" :class="copyButtonIcon"></i> {{ copyButtonText }}
                </button>
                <button v-else @click="handleModalClose" class="btn btn-secondary font-weight-bold shadow-sm px-4">
                    OK
                </button>
            </div>
        </template>
      </b-modal>
  
      <Navbar></Navbar>
  
      <div class="container pt-3 pb-5">

        <div class="row mb-4">
          <div class="col-12">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center border-bottom pb-3">
              <div class="mb-3 mb-md-0">
                <h2 class="font-weight-bold text-dark mb-1">
                  <i class="fas fa-box-open text-danger mr-2"></i> Refill Products
                </h2>
                <p class="text-muted mb-0">Manage device inventory and restock magazines</p>
              </div>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-white shadow-sm rounded mb-0 px-3 py-2 border">
                  <li class="breadcrumb-item">
                    <a href="#" @click.prevent="$router.push('/')" class="text-muted">
                      <i class="fas fa-home"></i> Home
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a href="#" @click.prevent="$router.push('/devices')" class="text-muted">Devices</a>
                  </li>
                  <li class="breadcrumb-item active font-weight-bold text-danger" aria-current="page">
                    Refill Device
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        
        <div class="row justify-content-center mb-4">
          <div class="col-12">
            <div class="card device-control-panel shadow-sm border-0">
              <div class="row no-gutters">
                
                <div class="col-lg-7 p-4 d-flex align-items-center border-right-lg">
                   <div class="device-icon-wrapper mr-3 mr-md-4">
                      <i class="fas fa-digital-tachograph"></i>
                    </div>
                    <div>
                      <h2 class="device-name mb-2">{{ DeviceSelected.name }}</h2>
                      <div class="device-meta">
                        <div class="badge badge-light border mr-2 text-wrap text-left p-2 mb-1" style="white-space: normal; line-height: 1.3;">
                          <i class="fas fa-map-pin text-danger mr-1 mt-1"></i> 
                          <span>{{ DeviceSelected.device_location }}</span>
                        </div>
                        <span class="text-muted small align-middle">
                          <i class="fas fa-map-marker-alt mr-1"></i> {{ DeviceSelected.area_name }}, {{ DeviceSelected.zone_name }}
                        </span>
                      </div>
                    </div>
                </div>
  
                <div class="col-lg-5 p-4 bg-light-panel d-flex flex-column justify-content-center">
                   <div class="d-flex justify-content-between align-items-center mb-3">
                      <span class="font-weight-bold text-dark">Current Status</span>
                      <span :class="tmode === true ? 'badge badge-pill badge-warning px-3 py-2' : 'badge badge-pill badge-success px-3 py-2'">
                        <i class="fas fa-circle small mr-1"></i> {{ tmode === true ? 'Test Mode' : 'Live Mode' }}
                      </span>
                   </div>
  
                   <div class="d-flex gap-2 mb-2">
                      <button @click="OnClickLiveMode()" class="btn btn-outline-success flex-fill shadow-sm font-weight-bold" :class="{'active': tmode !== true}">
                        <i class="fas fa-satellite-dish mr-1"></i> Live
                      </button>
                      <button @click="OnClickTestMode()" class="btn btn-outline-warning flex-fill shadow-sm font-weight-bold" :class="{'active': tmode === true}">
                        <i class="fas fa-tools mr-1"></i> Test
                      </button>
                    </div>
                    
                    <small class="text-muted text-center mt-1" style="font-size: 0.75rem;">
                      * টেস্ট করার জন্য Test Mode এবং শেষে Live Mode সিলেক্ট করুন।
                    </small>
                </div>
  
              </div>
            </div>
          </div>
        </div>
  
        <div class="table-container mt-3" v-if="magazines.length">
          
          <div v-if="agent_products && agent_products.length > 0">
              <h5 class="text-danger text-center font-weight-bold mb-3">
                আপনার কাছে যে সকল প্রোডাক্ট আছে তার তালিকা:
              </h5>
              
              <div class="d-block d-md-none">
                <div class="row">
                  <div class="col-12 mb-3" v-for="(item1, index) in agent_products" :key="'agent-mob-'+index">
                    <div class="card card-custom h-100">
                      <div class="card-body p-3">
                        
                        <div class="d-flex justify-content-between align-items-start mb-2">
                          <span class="badge badge-light border text-muted">
                            <i class="far fa-calendar-alt mr-1"></i> {{ parseDateString(item1.sending_date) }}
                          </span>
                          <small class="text-muted">SKU: {{ item1.sku }}</small>
                        </div>
      
                        <h5 class="product-title text-center mb-3">
                          {{ item1.product_type }}
                        </h5>
      
                        <div class="row no-gutters stat-box-container rounded bg-light border">
                          <div class="col-6 border-right text-center p-2">
                            <small class="text-uppercase text-muted font-weight-bold d-block">Full Packet</small>
                            <span class="count-highlight text-primary">{{ item1.count }}</span>
                          </div>
                          <div class="col-6 text-center p-2">
                            <small class="text-uppercase text-muted font-weight-bold d-block">Single Packet</small>
                            <span class="count-highlight text-info">{{ item1.single_count }}</span>
                          </div>
                        </div>
      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      
              <div class="d-none d-md-block table-responsive shadow-sm rounded">
                <table class="table table-bordered table-hover text-center bg-white mb-0">
                  <thead class="thead-dark">
                    <tr>
                      <th>Product</th>
                      <th>SKU</th>
                      <th>Full Packet</th>
                      <th>Single Packet</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item1, index) in agent_products" :key="'agent-desk-'+index">
                      <td>{{ item1.product_type }}</td>
                      <td>{{ item1.sku }}</td>
                      <td>{{ item1.count }}</td>
                      <td>{{ item1.single_count }}</td>
                      <td>{{ parseDateString(item1.sending_date) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <div v-else class="alert alert-warning text-center shadow-sm p-4" role="alert">
              <h5 class="mb-0 text-dark font-weight-bold">
                  <i class="fas fa-exclamation-circle text-danger mr-2"></i>
                  আপনার কাছে কোনো SKU নেই, রিফিল করতে হলে ইনভেন্টরি ম্যানেজারের সাথে যোগাযোগ করুন।
              </h5>
          </div>
        </div>

        <!-- Mismatch Navigation -->
        <div class="row justify-content-center mt-5 mb-2" v-if="magazines.length">
          <div class="col-12">
            <div class="alert alert-info d-flex flex-column flex-md-row align-items-center justify-content-between shadow-sm rounded p-4 mismatch-banner">
              <div class="mb-3 mb-md-0 text-center text-md-left">
                <h5 class="font-weight-bold text-dark mb-1">
                  <i class="fas fa-exclamation-triangle text-warning mr-2"></i> প্রোডাক্টের সংখ্যায় কি কোনো অমিল আছে?
                </h5>
                <p class="text-muted mb-0 small">
                  সার্ভারের হিসাব এবং ডিভাইসের ভেতরের প্রকৃত প্রোডাক্টের সংখ্যায় অমিল থাকলে এখান থেকে আপডেট করুন।
                </p>
              </div>
              <div>
                <button @click="goToMismatchPage" class="btn btn-warning font-weight-bold shadow-sm px-4 pulse-button">
                  <i class="fas fa-tools mr-1"></i> Report Mismatch
                </button>
              </div>
            </div>
          </div>
        </div>


  
        <div class="table-container mt-5" v-if="magazines.length">
          <h4 class="text-danger text-center font-weight-bold mb-3">এখান থেকে রিফিল করুন:</h4>
  
          <div class="d-block d-md-none">
            <div class="row">
              <div class="col-12 mb-3" v-for="(item1, index) in magazines" :key="'mob-'+index">
                
                <div class="card card-custom h-100">
                  <div class="card-body p-3">
                    
                    <div class="d-flex justify-content-between align-items-center mb-2">
                      <span class="badge badge-pill badge-light border text-uppercase px-2 py-1">
                        <i class="fas fa-ruler-horizontal mr-1"></i> Mag {{ item1.magazine_number }}
                      </span>
                      <span class="badge badge-pill badge-secondary border px-2 py-1">
                        <i class="fas fa-hashtag mr-1"></i>{{ item1.id }}
                      </span>
                      <span class="badge badge-pill badge-info border px-2 py-1">
                        <i class="fas fa-box mr-1"></i>{{ item1.pack_system.split(' ')[0] }}
                      </span>
                      <span class="availability-text">
                        <span class="count-highlight">{{ item1.count }}</span> 
                        <span class="text-muted"> / {{ item1.max_capacity }} Available</span>
                      </span>
                    </div>
          
                    <h5 class="product-title m-2">
                      {{ item1.product_type }}
                    </h5>
          
                    <div class="action-wrapper rounded bg-light">
                      <div class="d-flex align-items-center">
                          <div class="flex-grow-1 mr-2">
                            <b-form-input 
                              v-model.number="selectedRequestProduct[index]" 
                              type="number" 
                              class="form-control text-center shadow-sm border-1"
                              placeholder="Qty"
                              min="0"
                              :max="item1.max_capacity"
                              oninput="validity.valid||(value='');"
                            ></b-form-input>
                          </div>
                          
                          <div class="w-40">
                            <button 
                              @click="OnClickRefillProduct(item1, index)" 
                              :disabled="disableRefillButton"
                              :class="{'disabled': disableRefillButton}"
                              class="btn btn-danger w-100 shadow-sm"
                            >
                              Refill
                            </button>
                          </div>
                      </div>
                    </div>
          
                  </div>
                  <div class="progress" style="height: 4px;">
                    <div 
                      class="progress-bar" 
                      :class="getProgressColor(item1.count, item1.max_capacity)"
                      role="progressbar" 
                      :style="{ width: (item1.count / item1.max_capacity * 100) + '%' }"
                    ></div>
                  </div>
                </div>
          
              </div>
            </div>
          </div>
  
          <div class="d-none d-md-block table-responsive shadow-sm rounded">
            <table class="table table-bordered table-hover text-center bg-white align-middle mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>Mag</th>
                  <th>Ref</th>
                  <th>Product</th>
                  <th>Pack System</th>
                  <th>Capacity</th>
                  <th>Available</th>
                  <th style="min-width: 100px;">Refill Qty</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in magazines" :key="'desk-'+index">
                  <td class="align-middle">{{ item1.magazine_number }}</td>
                  <td class="align-middle">{{ item1.id }}</td>
                  <td class="align-middle">{{ item1.product_type }}</td>
                  <td class="align-middle">{{ item1.pack_system }}</td>
                  <td class="align-middle">{{ item1.max_capacity }}</td>
                  <td class="align-middle">{{ item1.count }}</td>
                  <td class="align-middle">
                    <b-form>
                      <b-form-group class="mb-0">
                        <b-form-input 
                            v-model.number="selectedRequestProduct[index]" 
                            type="number" 
                            class="text-center mobile-input"
                            placeholder="0"
                            min="0"
                            :max="item1.max_capacity"
                            oninput="validity.valid||(value='');"
                        ></b-form-input>
                      </b-form-group>
                    </b-form>
                  </td>
                  <td class="align-middle">
                    <button 
                      @click="OnClickRefillProduct(item1, index)" 
                      :disabled="disableRefillButton"
                      :class="{'disabled': disableRefillButton}"
                      class="btn btn-danger btn-sm w-100"
                    >
                      Refill
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
    </div>
  </template>
  
  <script>
  import Navbar from './components/Navbar.vue';
  import Loader from './components/Loader.vue';
  import { getAPI } from './axios-api.js';
  import { BFormInput, BFormGroup, BForm, BModal } from 'bootstrap-vue'
  import moment from 'moment'
  
  export default {
      name: 'Requsition',
      components: {
          Navbar,
          Loader,
          'b-form-input': BFormInput,
          'b-form-group': BFormGroup,
          'b-form': BForm,
          'b-modal': BModal
      },
  
      created() {
          this.loadData()
      },
      data() {
          return {
              DeviceSelected: '',
              DeviceSelectedName: '',
              magazines: '',
              selectedRequestProduct: [],
              agent_products: '',
              tmode: 'False',
              status: '',
              disableRefillButton: false, 
              isLoading: false,
              
              showModal: false,
              modalTitle: '',
              modalMessage: '',
              modalVariant: 'info',
              shouldReloadOnClose: false,

              // New Clipboard Variables
              showClipboard: false,
              clipboardText: '',
              copyButtonText: 'Copy Text',
              copyButtonIcon: 'fa-copy'
          }
      },
      methods: {
        parseDateString(date) {
            return moment(String(date)).format('DD.MM.YYYY')
        },
  
        showNotification(title, message, variant = 'primary', shouldReload = false, clipboardData = null) {
            this.modalTitle = title;
            this.modalMessage = message;
            this.modalVariant = variant;
            this.shouldReloadOnClose = shouldReload;
            
            if (clipboardData) {
                this.clipboardText = clipboardData;
                this.showClipboard = true;
                this.copyButtonText = 'Copy Text';
                this.copyButtonIcon = 'fa-copy';
            } else {
                this.showClipboard = false;
                this.clipboardText = '';
            }

            this.showModal = true;
        },
        async copyToClipboard() {
            try {
                // 1. Try modern clipboard API (HTTPS)
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(this.clipboardText);
                } 
                // 2. Fallback for mobile/HTTP testing
                else {
                    const textArea = document.createElement("textarea");
                    textArea.value = this.clipboardText;
                    textArea.style.position = "fixed";
                    textArea.style.left = "-999999px";
                    textArea.style.top = "-999999px";
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    const successful = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    if (!successful) throw new Error('Fallback copy failed');
                }

                // Visual Feedback
                this.copyButtonText = 'Copied!';
                this.copyButtonIcon = 'fa-check text-white';
                
                // Wait 800ms so the user sees "Copied!", then auto-close & refresh
                setTimeout(() => {
                    this.handleModalClose();
                }, 800);

            } catch (err) {
                console.error('Failed to copy text: ', err);
                alert("Failed to copy. Please manually select and copy the text.");
            }
        },
        handleModalClose() {
          this.showModal = false;
          if (this.shouldReloadOnClose) {
                this.shouldReloadOnClose = false; 
                // Wait 1 second (1000 milliseconds) before refreshing the page
                setTimeout(() => {
                    this.$router.go();
                }, 500);
            }
        },
  
        async loadData() {
            var disdata = {}
            this.DeviceSelectedName = localStorage.getItem('DeviceSelected')
            const payload = {
                name: this.DeviceSelectedName
            }
            
            getAPI.post('/singleProduct/', payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }).then(response => {
                disdata = response['data']['SRU'];
                this.DeviceSelected = disdata;
                if(disdata.test_mode) this.tmode = disdata.test_mode; 
            })
  
            getAPI.post('/getMagazines/', payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }).then(response => {
                this.magazines = response['data']['magazines']
                console.log(this.magazines)
            })
  
            getAPI.post('/agentProducts/', payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }).then(response => {
                this.agent_products = response['data']['agent_product']
            })
        },
  
        async OnClickRefillProduct(item, index) {
            const payload = {
                magazineInfo: item,
                quantity: '' + this.selectedRequestProduct[index],
                Device: this.DeviceSelectedName,
            };
  
            if (payload.quantity == 0 || !payload.quantity) {
                this.showNotification("ভুল ইনপুট", "Quantity ঘরে অবশ্যই ০-এর বেশি দিন।", "danger");
                return;
            } else if (((parseInt(payload.quantity) + parseInt(item.count)) > parseInt(item.max_capacity))) {
                this.showNotification("ভুল ইনপুট", "রিফিল পরিমাণ ডিভাইসের ধারণক্ষমতার চেয়ে বেশি।", "danger");
                return;
            }
  
            this.isLoading = true;
            this.disableRefillButton = true;
  
            try {
                const response = await getAPI.post('/refillProduct/', payload, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
                });
                console.log(response.data);
                const isTestMode = this.tmode === true;
                let successMessage = "রিফিল সম্পন্ন হয়েছে।";
                let reportText = null;

                // --- Start of Clipboard Logic ---
                if(!isTestMode) {
                  const beforeRefill = parseInt(item.count);
                  const refillAmount = parseInt(payload.quantity);
                  const afterRefill = beforeRefill + refillAmount;
                  const currentTime = moment().format('D/M/YYYY h:mm A');

                  const refillText = `*🔄 Refill Update*

*${this.DeviceSelectedName}*
Mag: ${item.magazine_number}

*${item.product_type}*
_(${item.pack_system})_

*Count:*
* Before: ${beforeRefill}
* Refill: *+${refillAmount}*
* After: ${afterRefill}

🕒 _${currentTime}_`;

                  successMessage = "রিফিল সম্পন্ন হয়েছে। নিচের তথ্যটি কপি করুন:";
                  reportText = refillText;

                }
                
                
                this.showNotification("সফল হয়েছে", successMessage, "success", true, reportText);
                this.isLoading = false;
                
            } catch (error) {
                console.error("Refill request failed:", error);
                let errorMessage = "রিফিল ব্যর্থ হয়েছে। আবার চেষ্টা করুন।";
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
                this.showNotification("ত্রুটি", errorMessage, "danger");
                
                this.isLoading = false; 
                this.disableRefillButton = false;
            } 
        },
  
        async OnClickTestMode() {
            const payload = {
                Device: this.DeviceSelectedName,
                Mode: 1,
            };
            
            getAPI.post('/modeChange/', payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }).then(() => {
                this.tmode = 'True';
                this.showNotification("স্ট্যাটাস পরিবর্তন", "ডিভাইস টি এখন টেস্ট মুডে আছে।", "warning", true);
            })
        },
  
        async OnClickLiveMode() {
            const payload = {
                Device: this.DeviceSelectedName,
                Mode: 0,
            };
  
            getAPI.post('/modeChange/', payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            }).then(() => {
                this.tmode = 'False';
                this.showNotification("স্ট্যাটাস পরিবর্তন", "ডিভাইস টি এখন লাইভ মুডে আছে।", "success", true);
            })
        },
        getProgressColor(count, max) {
          if (!max) return 'bg-secondary'; // Handle division by zero
          
          const percentage = (count / max) * 100;
          
          if (percentage <= 25) {
              return 'bg-danger'; // Red
          } else if (percentage <= 50) {
              return 'bg-warning'; // Yellow
          } else if (percentage <= 75) {
              return 'bg-info';   // Blue
          } else {
              return 'bg-success'; // Green
          }
        },
        goToMismatchPage() {
            this.$router.push('/mismatch'); 
        },
    }
  }
  </script>
  
  <style scoped>
  /* Mobile Optimizations */
  .device-control-panel {
    border-radius: 12px;
    overflow: hidden;
    border-right: 5px solid #dc3545 !important; /* Brand Accent */
  }
  
  .device-icon-wrapper {
    width: 60px;
    height: 60px;
    background: #f8f9fa;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.8rem;
    color: #dc3545;
    border: 1px solid #eee;
  }
  .device-name {
    font-weight: 800;
    color: #2d3436;
    margin: 0 0 8px 0;
    font-size: 1.8rem;
    line-height: 1.2;
  }
  .device-meta {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .meta-item {
    font-size: 1rem;
    color: #636e72;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .main-location {
    font-weight: 600;
    color: #444;
  }
  
  .sub-location {
    font-size: 0.9rem;
    opacity: 0.8;
  }
  .card-custom {
    border: 1px solid #c1c8ce;
    border-radius: 7px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    transition: transform 0.2s;
    overflow: hidden; /* Keeps progress bar inside corners */
  }
  
  .mobile-input {
      font-size: 1.1rem; 
      height: 40px;
  }
  
  .disabled {
      background: rgba(0, 0, 0, 0.2);
      color: white;
      border-color: transparent;
  }
  
  button.disabled:hover {
      cursor: default;
      animation: shake 0.6s cubic-bezier(.36, .07, .19, .97) both;
  }
  
  .count-highlight {
    font-weight: 600;
    font-size: 1.2rem;
  }

  .mismatch-banner {
    background-color: #f8fcfd;
    border: 1px solid #b8daff;
    border-right: 5px solid #ffc107 !important; /* Warning accent color */
  }

  .pulse-button {
    transition: transform 0.2s;
  }

  .pulse-button:hover {
    transform: scale(1.05);
  }

  @keyframes shake {
      10%, 90% { transform: translate3d(-1px, 0, 0); }
      20%, 80% { transform: translate3d(1px, 0, 0); }
      30%, 50%, 70% { transform: translate3d(-2px, 0, 0); }
      40%, 60% { transform: translate3d(2px, 0, 0); }
  }
  
  @media (max-width: 768px) {
      h2 { font-size: 1.5rem; }
      h4 { font-size: 1.2rem; }
      h5 { font-size: 1rem; }
      .btn-lg {
          width: 100%; 
          margin-bottom: 10px;
      }
      .device-info-card {
        padding: 1.2rem;
      }
      .device-header {
        justify-content: center;
      }
      .meta-item {
        justify-content: center;
      }
      .device-name {
        font-size: 1.4rem;
      }
  }
  </style>